import { css } from "@emotion/core";
export const style = {
    contain: css `
    position: relative;
  `,
    input: css `
    border: none;
    outline: none;
    font-size: inherit;
  `,
    mask: css `
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    background: #fff;
  `
};
